import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.0011 1.48999L1.81469 8.1643L11.0011 11.1491V1.48999Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.19604 10.0662L4.70517 20.8662L10.3831 13.0513L1.19604 10.0662Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.32406 22.0406H17.6781L12.0011 14.2268L6.32406 22.0406Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.2953 20.8638L22.8033 10.0671L13.6191 13.0513L19.2953 20.8638Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.1857 8.16488L13.0011 1.49184V11.1491L22.1857 8.16488Z"}}]};

const ChartRadarFilled = Vue.extend<IconProps>({
  name: 'ChartRadarFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chart-radar-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChartRadarFilled;
